import DisplayFilesByFileTrigger from './DisplayFilesByFileTrigger.component';

export default DisplayFilesByFileTrigger;
